import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const forRecruitersPage = {
    mobile: {
        header: {
            position: "relative",
            width: "100%",
            height: "127.78vw",
            background: Color.DeepBlack,               
            line: {
                height: "1px",
                borderWidth: 0,
                color: Color.LightBlue,
                backgroundColor: Color.LightBlue,
                margin: 0
            },
            backButton: {            
                width: "6.76vw",
                height: "6.76vw",
                backgroundColor: Color.White,
                boxShadow: "0px 0px 0px 1.45vw rgb(255 255 255 / 0.35)",
                borderRadius: "50%",       
                margin: "9.66vw 0 0 6.28vw",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",                   
                icon: {
                    fill: Color.MiddleBlack,
                    width: "2.90vw"
                }
            },
            title: {
                maxWidth: "71.01vw",
                color: Color.White,
                fontSize: "7.24vw",
                fontWeight: "bold",
                textAlign: "center",
                margin: "13.04vw auto 0 auto",
                blue: {
                    color: Color.Blue
                }
            },
            description: {
                position: "relative",
                maxWidth: "73.91vw",
                color: Color.White,
                fontSize: "2.90vw",
                fontFamily: Font.Poppins,
                textAlign: "center",
                margin: "4.83vw auto 0 auto",
                zIndex: 1
            },
            buttonWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                position: "relative",
                marginTop: "9.66vw",
                justifyContent: "center"
            },
            button: {            
                width: "43.96vw",
                height: "12.08vw",            
                color: Color.White,
                fontWeight: "bold" as "bold",            
                border: "none",
                borderRadius: "2.41vw",
                fontSize: "4.34vw",
                WebkitTapHighlightColor: "transparent",
                zIndex: 1,
                register: {
                    backgroundColor: Color.Blue,
                    marginRight: "1.21vw"
                },
                login: {
                    backgroundColor: Color.Green,
                    marginLeft: "1.21vw"
                }
            },
            backgroundSvg: {
                position: "absolute",
                width: "95.17vw",
                height: "53.14vw",
                bottom: "0",
                right: "0"
            }
        },
        subTitle: {
            fontSize: "3.86vw",
            color: Color.SharpAsh,
            fontWeight: "bold"
        },
        title: {
            fontSize: "7.24vw",
            fontWeight: "bold",
            marginTop: "2.41vw",
            color: Color.DeepBlack
        },
        services: {
            margin: "14.52vw 4.83vw 0 4.83vw",            
            image: {
                height: "56.28vw",
                width: "90.34vw",
                borderRadius: "4.83vw",
                marginTop: "9.66vw",
                boxShadow: "0px 0px 17px 0px rgba(0,0,0,0.19)"
            },
            mainImage: {
                display: "none"
            },
            aiAssistantImage: {
                height: "122vw",
                marginLeft: "14vw",
                marginTop: "12vw",
                borderRadius: "7.83vw",
                boxShadow: "0px 0px 17px 0px rgba(0,0,0,0.19)"
            },
            filterOutImage:{
                height: "auto",
                width: "87.34vw",
                borderRadius: "4.83vw",
                marginTop: "9.66vw",
                marginLeft: "2vw",
                boxShadow: "0px 0px 17px 0px rgba(0,0,0,0.19)"
            },
            trackCandidatesImage:{
                height: "58vw",
                width: "auto",
                borderRadius: "4.83vw",
                marginTop: "9.66vw",
                boxShadow: "0px 0px 17px 0px rgba(0,0,0,0.19)"
            },
            onlineQuizzesImage: {
                height: "85.28vw",
                width: "auto",
                borderRadius: "4.83vw",
                marginTop: "9.66vw",
                marginLeft: "10vw",
                boxShadow: "0px 0px 17px 0px rgba(0,0,0,0.19)"
            },
            muchNeededImage: {
                height: "56.28vw",
                width: "90.34vw",
                borderRadius: "4.83vw",
                marginTop: "9.66vw",
                boxShadow: "0px 0px 17px 0px rgba(0,0,0,0.19)"
            },
            mainDetailContainer: {
                marginLeft: "4.83vw"
            },
            heading: {
                width: "71.01vw",
                fontSize: "6.04vw",
                fontWeight: "bold",
                margin: "7.24vw 0 0 4.83vw",
                color: Color.DeepBlack
            },
            description: {
                width: "75.12vw",
                fontFamily: Font.Poppins,
                fontSize: "3.62vw",
                margin: "4.83vw 0 0 6vw",
                color: Color.MiddleBlack,
                textAlign: "justify" as "justify"
            },
            leadingApplicationDescription: {
                width: "75.12vw",
                fontFamily: Font.Poppins,
                fontSize: "3.62vw",
                textAlign: "justify" as "justify",
                margin: "4.83vw 0 0 0",
                color: Color.MiddleBlack
            }
        },
        columnRowReverse: {
            display: "flex",
            flexDirection: "column"
        },
        green: {
            color: Color.Green
        },
        blue: {
            color: Color.Blue
        },
        greenToBlack: {
            color: Color.Green
        },
        greenBackground: {
            backgroundColor: Color.Green
        },
        blueBackground: {
            backgroundColor: Color.Blue
        },
        blackBackground: {
            backgroundColor: Color.DeepBlack
        },
        hrNewsUrl: {
            color: Color.Blue
        },
        dotsWrapper: {
            position: "relative",
            bottom: "0",
            width: "100%"
        },
        dots: {            
            marginBottom: "0%", 
            marginLeft: "-20%",
            color: Color.Blue
        },
        testimonialSliderDots: {
            marginBottom: "0%", 
            marginLeft: "-20%",
            color: Color.Blue
        },
        logoGride: {
            marginTop: "25.36vw",
            logo: {
                width: "8.69vw",
                height: "8.69vw",
                borderRadius: "2.41vw",
                marginRight: "8.69vw",
                normal: {
                    WebkitFilter: "none",
                    filter: "none",
                    opacity: "1"
                },
                hover: {
                    opacity: "1"
                }
            },
            row: {
                paddingLeft: "0"
            },
            nextRow: {
                marginTop: "7.97vw",
                marginLeft: "-3.14vw"
            },
            loaderBox: {
                width: "8.69vw",
                height: "8.69vw",                
                marginRight: "8.69vw",
                marginTop: "0"
            },
            loaderContainer: {
                marginTop: "25.36vw",
                textAlign: "enter"
            }
        },
        cvLess: {
            display: "flex",
            flexDirection: "column",
            marginTop: "20.19vw",
            overflow: "hidden",
            videoContainer: {
                height: "60.14vw",
                display: "flex",
                justifyContent: "center"
            },
            video: {
                width: "90.34vw",
                height: "52.90vw",
                border: "none",
                borderRadius :"4.83vw",
                backgroundColor: Color.Black
            },
            content: {
                margin: "9.66vw 4.83vw 0 4.83vw"
            },
            description: {
                textAlign: "justify",
                marginTop: "7.24vw",
                fontFamily: Font.Poppins,
                fontSize: "3.62vw",                
                color: Color.MiddleBlack
            }
        },
        features: {
            overflow: "hidden",
            slider: {
                marginTop: "21.74vw"
            },
            grid: {
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gridGap: "3.64vw 0",
                margin: "10.42vw 0 0 7.29vw"
            },
            card: {
                padding: "13.28vw 9.66vw",
                backgroundColor: Color.Cultured,
                height: "115vw"
            },
            iconWrapper: {
                height: "14.49vw",
                width: "14.49vw",                
                borderRadius: "50%",
                textAlign: "center"                
            },
            iconSMS: {
                height: "4.88vw",
                width: "4.88vw",
                marginTop: "5.23vw"
            },
            iconUserCheck: {
                height: "4.49vw",
                width: "5.61vw",
                marginTop: "4.85vw"
            },
            iconDatabase: {
                height: "5.41vw",
                width: "4.73vw",
                marginTop: "4.51vw"
            },
            iconTarget: {
                height: "7.11vw",
                width: "7.11vw",
                marginTop: "3.66vw",
                overflow: "visible"
            },
            iconNote: {
                height: "5.10vw",
                width: "5.10vw",
                marginTop: "4.67vw"
            },
            iconSpeaker: {
                height: "auto",
                width: "auto",
                marginTop: "0.48vw",
                transform: "scale(0.5)"
            },
            recruitments: {
                height: "15vw",
                width: "14vw",
                marginTop: "0",
                transform: "scale(0.5)"
            },
            email: {
                height: "6.41vw",
                width: "7.73vw",
                marginTop: "4.51vw"
            },
            whatsapp: {
                height: "8vw",
                width: "8vw",
                margin: "3vw 0 1.1vw 0.5vw"
            },
            hangingSign: {
                height: "10vw",
                width: "10vw",
                marginTop: "2.4vw",
                marginLeft: "1vw"
            },
            title: {
                fontSize: "3.86vw",
                fontWeight: "bold",
                marginTop: "3.62vw",
                color: Color.DeepBlack
            },
            description: {
                fontFamily: Font.Poppins,
                textAlign: "justify" as "justify",
                fontSize: "3.62vw",
                marginTop: "3.62vw",
                color: Color.MiddleBlack
            }
        },
        careers: {
            display: "flex",
            flexDirection: "column",
            margin: "24.15vw 4.83vw 0 4.83vw",
            image: {
                height: "56.28vw",
                width: "90.34vw",
                borderRadius: "4.83vw"
            },
            heading: {
                fontSize: "6.04vw",
                fontWeight: "bold",
                marginTop: "7.24vw",
                color: Color.DeepBlack
            },
            description: {
                fontFamily: Font.Poppins,
                fontSize: "3.62vw",
                textAlign: "justify" as "justify",
                marginTop: "4.83vw",
                color: Color.MiddleBlack
            }
        },
        packages: {
            margin: "31.40vw 4.83vw 0 4.83vw",
            card: {
                width: "99%",
                backgroundColor: Color.LightBlue,
                borderRadius: "4.83vw",
                textAlign: "-webkit-center",
                margin: "7.24vw 0.5% 9.66vw 0.5%",
                height: "200vw",
                popular: {
                    marginBottom: "4.59vw"
                }
            },
            popular: {
                height: "8.99vw",
                lineHeight: "8.99vw",
                borderRadius: "4.83vw 4.83vw 0 0",
                backgroundColor: Color.Red,
                color: Color.White,
                fontSize: "3.86vw"
            },
            price: {
                paddingTop: "2.08vw",
                marginBottom: "7.08vw",
                fontWeight: 700,
                fontSize: "5.80vw",
                color: Color.Blue,
                position: "relative",
                textAlign: "center"
            },
            cvLimit: {
                paddingTop: "4.08vw",
                margin: "0 0 2.83vw 0",
                fontWeight: 700,
                fontSize: "10.87vw",
                color: Color.DeepBlack
            },
            featureEnable: {
                width: "70.77vw",
                fontFamily: Font.Poppins,
                fontWeight: 600,
                fontSize: "3.62vw",
                color: Color.LightBlack,
                textAlign: "center",
                marginBottom: "2.41vw"
            },
            featureDisable: {
                fontWeight: 400,
                color: Color.MiddleBlack,
                textDecorationLine: "line-through"
            },
            button: {
                height: "12.08vw",
                width: "66.18vw",
                borderRadius: "2.41vw",
                backgroundColor: Color.Blue,
                color: Color.White,
                fontSize: "4.35vw",
                fontWeight: 700,
                position: "absolute",
                bottom: 13,
                marginLeft: "12vw"
            },
            packageTypeButton: {
                display: "flex",
                alignItems: "center",
                marginTop: "7.24vw",
                fontSize: "3.86vw",
                fontWeight: "bold" as "bold",   
                color: Color.SharpAsh,
                cvBased: { 
                    marginLeft: "12.6vw",
                    marginRight: "7.24vw"
                },
                unlimited: {
                    marginLeft: "7.24vw"
                }
            },
            toggleButton: {
                switch: {
                     marginLeft: "unset",
                    backgroundColor: Color.SharpGreen,
                    checked: {
                        backgroundColor: Color.BrightGray
                    }
                },
                switchCircle: {
                    backgroundColor: Color.Green,
                    checked: {
                        backgroundColor: Color.DarkGray
                    }
                }
            },
            chevronLeftIcon: {
                height: "7.24vw",
                width: "4.34vw",
                position: "absolute",
                marginTop: "0",
                left: "0",
                marginLeft: "2.89vw"
            },
            chevronRightIcon: {
                height: "7.24vw",
                width: "4.34vw",
                position: "absolute",
                marginTop: "0",
                right: "0",
                marginRight: "2.89vw" 
            },
            annualChevronRightIcon: {
                marginTop: "0"
            }
        },
        crossPublishing: {
            padding: "7.24vw 0",
            description: {
                margin: 0,
                fontFamily: Font.Poppins,
                fontSize: "3.62vw",
                fontWeight: 500,
                lineHeight: 1.6,
                color: Color.MiddleBlack,
                textAlign: "justify"
            },
            title: {
                marginTop: "12.31vw"
            },
            descriptionMark: {
                display: "none"
            },
            descriptionLink: {
                fontFamily: Font.Poppins,
                color: Color.Blue,
                textDecoration: "none"
            },
            brandList: {
                display: "flex",
                flexDirection: "column" as "column",
                alignItems: "center",
                gap: "5.8vw",
                marginTop: "6.04vw"
            },
            brandLink: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "68vw",
                height: "14vw",
                textDecoration: "none",
                myJobs: {
                    width: "82vw",
                    height: "20vw"
                },
                hrNews: {
                    width: "72vw",
                    height: "16vw"
                }
            },
            brandLogo: {
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain" as "contain"
            }
        },
        specialPackage: {
            marginTop: "25.74vw",
            background: {
                marginLeft: "4.83vw",
                width: "90.33vw",
                height: "81.15vw",
                borderRadius: "4.83vw",
                backgroundColor: Color.DeepBlack,
                transition: "height 0.5s ease",
                expand: {
                    height: "140.15vw"
                }
            },
            title: {
                paddingLeft: "7.24vw",
                paddingTop: "7.48vw",
                color: Color.White,
                fontWeight: "bold" as "bold", 
                fontSize: "3.86vw"
            },
            description: {
                color: Color.Green,
                fontWeight: "bold" as "bold", 
                fontSize: "7.24vw",
                padding : "7.48vw 7.24vw 0"
            },
            button: {
                height: "12.08vw",
                width: "66.18vw",
                borderRadius: "2.41vw",
                backgroundColor: Color.Blue,
                margin: "4.83vw 0 0 7.24vw",
                color: Color.White,
                fontSize: "4.35vw",
                fontWeight: 700
            },
            expand: {
                marginTop: "4.83vw",
                marginLeft: "7.24vw",
                color: Color.SharpAsh,
                fontSize: "3.86vw",
                fontWeight: "bold" as "bold"
            },
            expandIcon: {
                height: "3.58vw",
                width: "3.1vw",
                fill: Color.SharpAsh,                
                marginLeft: "2vw",
                paddingTop: "0.5vw",
                position: "absolute",
                up: {
                    transform: "rotate(180deg)"
                }
            },
            slider: {
                color: Color.White,
                marginTop: "5vw"
            },
            featureTitle: {
                textAlign: "center",
                fontWeight: "bold" as "bold"
            },
            features: {
                marginBottom: "2vw",
                marginLeft: "4vw"
            },
            featureText: {
                fontFamily: "Poppins",
                fontSize: "4.34vw"
            }
        },
        review: {
            width: "98%",
            buttonWrapper: {
                display: "none",
                flexDirection: "row" as "row"                
            },
            rightButton: {
                width: "3.4vw",
                height: "3.4vw",
                borderRadius: "50%",
                borderWidth: "0.5vw",
                backgroundColor: Color.Blue,
                borderColor: Color.LightBlue,
                border: "0.5vw solid " + Color.SharpBlue,
                margin: "0 7.29vw 0 1.30vw",
                cursor: "pointer",
                fill: Color.White
            },
            buttonIcon: {
                width: "45%",
                height: "auto"
            },
            leftButton: {
                width: "3.5vw",
                height: "3.5vw",
                borderRadius: "50%",
                backgroundColor: Color.LightAsh,
                borderColor: Color.White,
                border: "0.3vw solid white",
                marginLeft: "auto",
                cursor: "pointer",
                fill: Color.SharpAsh                  
            },
            slider: {
                display: "block",
                margin: "24.15vw 4.83vw 0 4.83vw"
            },
            card:{            
                borderRadius: "4.83vw",
                border: "0.96vw solid " + Color.LightBlue,            
                marginTop: "3.57vh",
                rowWrapper: {
                    display: "flex",
                    flexDirection: "row" as "row"
                },
                title: {
                    width: "60%",
                    margin: "4.46vh 0 0 4.83vw",
                    fontFamily: "Poppins",
                    fontSize: "4.83vw",
                    fontWeight: "bold" as "bold",
                    textAlign: "left" as "left",
                    height: "14vw",
                    overflowY: "hidden",
                    hover: {
                        overflowY:"auto"
                    }
                },
                quoteIcon: {
                    width: "25.84vw",
                    height: "10.82vh",
                    float: "right" as "right",
                    margin: "2.23vh 4.83vw 0 0",
                    fill: Color.LightBlue    
                },
                starWrapper: {
                    margin: "3.34vh 0 0 4.83vw",
                    textAlign: "left" as "left",
                },
                star: {
                    marginRight: "0.72vw"
                },
                description: {
                    height: "13.50vh", 
                    margin: "1.11vh 4.83vw 0 4.83vw",
                    fontSize: "3.38vw",                    
                    textAlign: "left" as "left",
                    color: Color.MiddleBlack,
                    lineHeight: 1.6,
                    overflowY: "hidden",
                    hover:{
                        overflowY:"visible"
                    }
                },
                userWrapper: {                
                    textAlign: "left" as "left",
                    margin: "3.34vh 0 2.23vh 4.83vw"
                },
                userLogo: {
                    width: "10.14vw",
                    height: "10.14vw",                
                    borderRadius: "6.03vw",
                    objectFit: "cover"        
                },
                userName: {
                    fontFamily: "Poppins",
                    fontSize: "3.62vw",
                    fontWeight: "bold" as "bold",
                    color: Color.Black,
                    marginTop: "1.11vh"
                },
                userJobTitle: {                
                    fontFamily: "Poppins",
                    fontSize: "3.38vw",                    
                    color: Color.Black,
                    marginTop: "0.22vh"
                },
                organization: {
                    display: "none"
                },
                organizationLogoWrapper: {
                    height: "17vw",
                    margin: "5vw 2vw 0 17vw"    
                },
                organizationLogo:{
                    width: "31.64vw",
                    height: "15.94vw",                
                    borderRadius: "3.62vw",
                    objectFit: "contain",
                    border:"2px solid" + Color.LightAsh
                },
                bottomWrapper: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    height: "45vw"
                }                
            }
        },
        faqs: {
            display: "flex",
            flexDirection: "column",
            margin: "31.91vw 4.83vw 0 4.83vw",            
            title: {
                width: "66.67vw"
            },
            description: {
                margin: "7.24vw 0",
                fontFamily: Font.Poppins,
                fontSize: "3.62vw",
                color: Color.MiddleBlack
            },            
            questions: {
                marginTop: "5.79vw"
            },
            FAQs: {
                subTitle: {
                    color: Color.DeepAsh,
                    fontFamily: Font.Poppins,
                    fontSize: "3.86vw",
                    marginTop: "0",
                    marginLeft: "0",
                    fontWeight: "bold" as "bold"
                },
                wrapper: {
                    display: "flex",
                    flexDirection: "column" as "column",
                    marginTop: "1.20vw"
                },
                tabsWrapper: {
                    position: "relative" as "relative",
                    width: "90.33vw"
                },
                tabs: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    gap: "2.41vw",
                    width: "90.33vw",
                    marginBottom: "5.56vw",
                    overflowX: "auto" as "auto",
                    overflowY: "hidden" as "hidden",
                    WebkitOverflowScrolling: "touch",
                    scrollbarWidth: "none"
                },
                tabButton: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    alignItems: "center" as "center",
                    justifyContent: "center",
                    flex: "0 0 auto",
                    width: "auto",
                    height: "8.21vw",
                    fontSize: "3.38vw",
                    fontFamily: Font.Poppins,
                    paddingLeft: "3.62vw",
                    paddingRight: "3.62vw",
                    backgroundColor: Color.White,
                    border: "0.10vw solid " + Color.LightSliverGray,
                    borderRadius: "4.10vw",
                    marginBottom: "0",
                    color: Color.DeepAsh,
                    whiteSpace: "nowrap" as "nowrap",
                    active: {
                        fontWeight: "bold" as "bold",
                        backgroundColor: Color.DeepBlack,
                        border: "0.10vw solid " + Color.DeepBlack,
                        color: Color.White
                    }
                },
                moreTopicsButton: {
                    position: "absolute" as "absolute",
                    top: "0",
                    right: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "8.21vw",
                    height: "8.21vw",
                    border: "none",
                    borderRadius: "50%",
                    backgroundColor: Color.DeepBlack,
                    color: Color.White,
                    fontFamily: Font.Poppins,
                    fontSize: "6.10vw",
                    fontWeight: "bold" as "bold",
                    lineHeight: "1",
                    boxShadow: "0 1.45vw 3.62vw rgba(0, 0, 0, 0.35)",
                    cursor: "pointer",
                    zIndex: 1
                },
                categoryIcon: {
                    display: "none",
                    active: {
                        fill: Color.Black,
                        width: "3.10vw",
                        height: "3.58vw"
                    }
                },
                activeIcon: {
                    display: "none"
                },
                contents: {
                    marginTop: "1.5vw",
                    marginBottom: "1.5vw"
                },
                content: {
                    question: {
                        display: "flex",
                        flexDirection: "row" as "row",
                        alignItems: "center" as "center",
                        justifyContent: "space-between",
                        color: Color.DeepAsh,
                        fontSize: "3.80vw",
                        width: "85.33vw",
                        height: "auto",
                        cursor: "pointer",
                        fontFamily: Font.Default,
                        borderRadius: "2.41vw",
                        backgroundColor: Color.LightAsh,
                        marginBottom: "2.41vw",
                        overflow: "hidden" as "hidden",
                        lineHeight: "4vw",
                        padding: "1.50vw 1.25vw 1.50vw 4.10vw",
                        fontWeight: "bold" as "bold",
                        active: {
                            backgroundColor: Color.DeepBlack,
                            color: Color.White,
                            fontWeight: "bold" as "bold"
                        }
                    },
                    text: {
                        fontSize: "3.86vw",
                        color: Color.GraniteGray,
                        fontWeight: "bold" as "bold",
                        marginLeft: "4.10vw",
                        paddingTop: "2.65vw",
                        width: "76.32vw",
                        fontFamily: Font.Poppins,
                        active: {
                            color: Color.White
                        }
                    },
                    dropdownIcon: {
                        width: "4.17vw",
                        height: "4.58vw",
                        fill: Color.GraniteGray,
                        marginRight: "3.00vw",
                        marginLeft: "3.50vw",
                        marginTop: "1.65vw",
                        transition: "transform .3s ease-in-out",
                        active: {
                            transform: "rotate(180deg)",
                            fill: Color.White
                        }
                    },
                    answer: {
                        width: "81.40vw",
                        fontSize: "3.62vw",
                        lineHeight: "5.5vw",
                        fontWeight: "500",
                        padding: "4.83vw 0 7.24vw 4.83vw",
                        fontFamily: Font.Poppins,
                        color: Color.MiddleBlack,
                        maxHeight: "0",
                        overflow: "hidden",
                        transition: "max-height 0.5s ease, padding 0.5s ease",
                        active: {
                            maxHeight: "500px",
                            padding: "4.83vw 0 7.24vw 4.83vw"
                        },
                        inactive: {
                            maxHeight: "0",
                            padding: "0 0 0 1.56vw"
                        }
                    },
                    paragraph: {
                        margin: '0 0 1vw 0',
                        fontFamily: Font.Poppins
                    }
                }
            }
        },
        register: {
            position: "relative",
            height: "53.38vw",
            borderRadius: "4.83vw",
            backgroundColor: Color.Blue,
            margin: "24.15vw 4.83vw 0 4.83vw",            
            textAlign: "center",
            text: {
                padding: "7.48vw 6.52vw 0 6.52vw",
                fontSize: "7.25vw",                
                color: Color.White,
                fontWeight: 700,
                zIndex: "1",
                position: "relative"
            },
            button: {
                height: "12.08vw",
                width: "43.96vw",
                marginTop: "3.62vw",
                backgroundColor: Color.DeepBlack,
                color: Color.White,
                fontSize: "4.35vw",
                borderRadius: "2.41vw",
                fontWeight: 700,
                zIndex: "1",
                position: "relative"
            },
            backgroundSvg: {
                position: "absolute",
                left: 0,
                bottom: 0,
                marginLeft: "-5vw",
                height: "115%"
            }
        },
        bestHire: {
            display: "flex",
            flexDirection: "column",
            margin: "16.91vw 4.83vw 0 4.83vw",  
            textAlign: "-webkit-center",            
            description: {
                width: "78.74vw",
                fontFamily: Font.Poppins,
                fontSize: "3.62vw",
                marginTop: "7.25vw",
                color: Color.MiddleBlack
            },
            video: {
                height: "57.25vw",
                border: "none",
                borderRadius :"4.83vw",
                marginTop: "9.66vw"
            }
        }
    },
    desktop: {
        header: {            
            height: "24.27vw",              
            line: {
                height: "1px"
            },
            backButton: { 
                display: "none"
            },
            title: {
                maxWidth: "51.51vw",            
                fontSize: "3.38vw",            
                margin: "2.81vw auto 0 auto"
            },
            description: {
                maxWidth: "48.38vw",            
                fontSize: "0.94vw",
                margin: "1.56vw auto 0 auto"
            },
            buttonWrapper: {
                marginTop: "1.56vw"
            },
            button: {            
                width: "14.58vw",
                height: "3.64vw",
                borderRadius: "0.52vw",
                fontSize: "1.04vw",
                register: {
                    marginRight: "0.625vw"
                },
                login: {
                    marginLeft: "0.625vw"
                }
            },
            backgroundSvg: {
                width: "100%",
                height: "16.145vw"
            }
        },
        subTitle: {
            fontSize: "1.56vw"
        },
        title: {
            fontSize: "2.86vw",                
            marginTop: "1.04vw"                
        },
        greenToBlack: {
            color: Color.DeepBlack
        },
        services: {
            margin: "7.29vw 12.48vw 0 9.29vw",            
            image: {
                height: "21.875vw",
                width: "40.10vw",
                borderRadius: "1.04vw",
                marginTop: "0",
            },
            aiAssistantImage: {
                height: "39.875vw",
                borderRadius: "2.04vw",
                marginTop: "0",
                marginRight: "5vw"
            },
            filterOutImage:{
                height: "auto",
                width: "48vw",
                borderRadius: "1.04vw",
                marginTop: "0",
                marginLeft: "6vw",
            },
            trackCandidatesImage:{
                height: "auto",
                width: "52.1vw",
                borderRadius: "1.04vw",
                marginTop: "0"
            },
            onlineQuizzesImage:{
                height: "38.875vw",
                width: "auto",
                borderRadius: "1.04vw",
                marginTop: "0",
                marginLeft: "2vw"
            },
            muchNeededImage: {
                height: "auto",
                width: "49.10vw",
                borderRadius: "1.04vw",
                marginTop: "0"
            },
            mainImage: {
                display: "visible",
                height: "auto",
                width: "41.10vw",
                borderRadius: "1.04vw",
                marginTop: "0",
                marginLeft: "-5vw"
            },
            reverseContainer: {
                display: "flex",
                flexDirection: "row-reverse" as "row-reverse",
                alignItems: "center",
                justifyContent: "space-between",
                margin: "3.5vw 0 0 0"
            },
            normalContainer: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "5.5vw",
                marginLeft: "2vw"
            },
            trackCandidateContainer: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "5.5vw",
                marginLeft: "-5vw"
            },
            filterOutContainer: {
                display: "flex",
                flexDirection: "row-reverse" as "row-reverse",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "2.5vw",
                marginRight: "-7.5vw"
            },
            aiAssistantContainer: {
                display: "flex",
                flexDirection: "row-reverse" as "row-reverse",
                alignItems: "center",
                justifyContent: "space-between"
            },
            muchNeededContainer: {
                display: "flex",
                flexDirection: "row-reverse" as "row-reverse",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "6vw",
                marginTop: "5.5vw",
                marginRight: "-9.5vw"
            },
            onlineQuizzesContainer: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "3.5vw"
            },
            mainDetailContainer: {
                width: "35vw"
            },
            heading: {
                width: "auto",
                fontSize: "1.82vw",                
                margin: "2.60vw 0 0 1.04vw"                
            },
            description: {
                width: "35vw",                
                fontWeight: 500,
                fontSize: "0.94vw",
                margin: "1.56vw 0 0 1.04vw",
                color: Color.SharpAsh
            },
            detailContainer: {
                marginTop: "-3.60vw"
            },
            trackCandidatesDetailContainer:{
                marginTop: "-3.60vw",
                marginLeft: "2.04vw"
            },
            muchNeededDetailContainer:{
                marginTop: "-3.60vw",
                marginRight: "0"
            },
            filterOut: {
                width: "35.10vw",
                marginRight: "8.02vw"
            },
            trackCandidates: {
                width: "35.10vw",
                marginTop: "-18vw"
            },
            leadingApplicationDescription: {
                width: "auto",                
                fontWeight: 500,
                fontSize: "0.94vw",
                margin: "1.56vw 0 0 0",
                color: Color.SharpAsh
            }
        },
        columnRowReverse: {            
            flexDirection: "row-reverse" as "row-reverse"
        },
        dots: {            
            marginLeft: "-30%"
        },
        testimonialSliderDots: {
            marginLeft: "-8vw"
        },
        logoGride: {
            marginTop: "8.54vw",
            logo: {
                width: "3.80vw",
                height: "3.85vw",
                borderRadius: "0.52vw",
                marginRight: "3.75vw"
            },
            loaderContainer: {
                marginTop: "8.54vw"
            },
            loaderBox: {
                marginTop: "unset",
                width: "3.8vw",
                height: "3.8vw",
            }
        },
        cvLess: {            
            flexDirection: "row",
            alignItems: "center",
            marginTop: "4.41vw",
            height: "38vw",
            paddingBottom: "3.12vw",            
            videoContainer: {
                height: "33.70vw",
                width: "56.77vw"
            },
            video: {
                width: "43.77vw",
                height: "26.61vw",
                borderRadius :"1.04vw",
                marginLeft: "5vw",
                marginTop: "6vw"            
            },
            content: {
                width: "35vw",
                margin: "0vw 7.29vw 0 0"
            },
            description: {
                marginTop: "2.60vw",                
                fontSize: "0.94vw", 
                fontWeight: 500,
                color: Color.SharpAsh
            }
        },
        features: { 
            height: "auto",           
            card: {
                width: "24.43vw",
                height: "auto",
                padding: "unset",
                backgroundColor: "transparent"
            },
            grid: {
                margin: "4.12vw 0 0 7.29vw"
            },
            iconWrapper: {
                height: "6.35vw",
                width: "6.35vw"               
            },
            iconSMS: {
                height: "2.12vw",
                width: "2.12vw",
                marginTop: "2.32vw"
            },
            iconUserCheck: {
                height: "1.97vw",
                width: "2.47vw",
                marginTop: "2.13vw"
            },
            iconDatabase: {
                height: "2.38vw",
                width: "2.08vw",
                marginTop: "1.99vw"
            },
            iconTarget: {
                height: "3.13vw",
                width: "3.13vw",
                marginTop: "1.61vw"
            },
            iconNote: {
                height: "2.24vw",
                width: "2.24vw",
                marginTop: "2.05vw"
            },
            iconSpeaker: {
                height: "2.74vw",
                width: "2.74vw",
                marginTop: "1.6vw",
                transform: "none"
            },
            recruitments: {
                height: "7vw",
                width: "7vw",
                marginTop: "-0.2vw",
                marginLeft: "-0.2vw"
            },
            email: {
                height: "3vw",
                width: "3vw",
                marginTop: "1.55vw"
            },
            whatsapp: {
                height: "3.08vw",
                width: "3.08vw",
                marginTop: "1.5vw",
                marginLeft: "0.3vw"
            },
            hangingSign: {
                height: "4.21vw",
                width: "4.21vw",
                margin: "1.12vw 1.2vw"
            },
            title: {
                fontSize: "1.82vw",                
                marginTop: "2.60vw"                
            },
            description: {                
                fontWeight: 500,
                fontSize: "0.94vw",
                marginTop: "1.56vw",
                color: Color.SharpAsh
            }
        },
        careers: {            
            flexDirection: "row-reverse",
            margin: "7.81vw 7.29vw 0 7.29vw",
            image: {
                height: "auto",
                width: "46.29vw",
                borderRadius: "1.04vw"
            },
            wrapper: {
                marginRight: "auto"
            },
            heading: {
                fontSize: "1.82vw",                
                marginTop: "9.11vw"                
            },
            description: {                
                width: "34.16vw",
                fontSize: "0.94vw",
                fontWeight: 500,
                marginTop: "1.56vw",
                color: Color.SharpAsh
            }
        },
        packages: {
            margin: "12.5vw 7.29vw 0 7.29vw",
            subTitle: {
                color: Color.LightBlack
            },
            title: {
                width: "51.51vw"
            },
            table: {
                marginTop: "3.78vw",
                borderSpacing: "0",
                firstRow: {
                    height: "5vw"
                },
                lastRow: {
                    boxShadow: "0px 0px 0px 1px #0000001A",
                    borderRadius: "0 0 0.52vw 0.52vw"
                }
            },
            included: {
                width: "16.32vw"
            },
            tableHead: {
                width: "16.32vw",
                height: "9vw",
                borderLeft: "1px solid" + Color.MiddleAsh,
                hovered: {
                    backgroundColor: Color.White,
                    boxShadow: "0px 0px 0px 1px #0000001A",
                    borderRadius: "0.52vw 0.52vw 0 0"
                },
                nextColumnHovered: {
                    borderLeft: "1px solid transparent"
                },
                prevColumnHovered: {
                    borderRight: "1px solid transparent"
                }
            },
            headBorderBlack: {
                borderLeft: "2px solid" + Color.Black,
                borderRight: "2px solid" + Color.Black
            },
            body: {
                borderTop: "1px solid" + Color.MiddleAsh
            },
            bodyBorderBlack: {
                borderLeft: "2px solid" + Color.Black,
                borderRight: "2px solid" + Color.Black
            },
            tableHeading: {
                display: "block",
                width: "6.41vw",
                fontWeight: 700,
                fontSize: "1.56vw",
                color: Color.LightBlack,
                textAlign: "left"
            },
            popular: { 
                height: "2.3vw",
                lineHeight: "2.3vw",
                borderRadius: "none",
                backgroundColor: Color.Black,
                color: Color.White,
                fontSize: "0.94vw",
                margin: "0 -0.2vw -0.2vw"
            },
            price: {
                paddingTop: "0.6vw",
                marginBottom: "1.25vw",                
                fontSize: "1.25vw",
                color: Color.Black                
            },
            textBlue: {
                color: Color.Blue
            },
            unlimitedCVPrice: {
                fontSize: "1.25vw"
            },
            lkr: { 
                fontWeight: 700,
                fontSize: "1.25vw",
                color: Color.Black
            },
            cvLimit: {
                paddingTop: "0.25vw",
                margin: "0.5vw 0 0.4vw 0",                
                fontSize: "2vw",
                color: Color.SharpAsh
            },
            unlimitedCVText: {
                color: Color.Red,
                fontSize: "2vw"
            },
            featureEnable: {
                display: "block",
                width: "11.77vw",                
                fontWeight: 500,
                fontSize: "0.94vw",
                color: Color.SharpAsh,
                textAlign: "left",
                margin: "0.44vw 0"
            },
            twoJobsPosting: {
                display: "inline",
                width: "auto",
                marginRight: "0.4vw"
            },
            twoJobsPostingWrapper: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%"
            },
            cellWrapper: {
                textAlign: "center",
                borderLeft: "1px solid" + Color.MiddleAsh,
                borderTop: "1px solid" + Color.MiddleAsh,   
                hovered: {
                    backgroundColor: Color.White,
                    boxShadow: "0px 0px 0px 1px #0000001A"
                },
                nextColumnHovered: {
                    borderLeft: "1px solid transparent"
                },
                prevColumnHovered: {
                    borderRight: "1px solid transparent"
                }
            },
            enableIcon: {
                height: "1.3vw",
                width: "1.3vw",
                overflow: "visible",
                marginTop: "0.3vw"
            },
            button: {
                height: "2.19vw",
                width: "12.50vw",
                borderRadius: "0.52vw",                
                marginLeft: "-6.2vw",
                bottom: "none",                
                fontSize: "0.83vw"                
            },
            unlimitedCVButton: {
                marginTop: "-1vw"
            },
            annualCVButton: {
                marginTop: "-0.6vw"
            },
            packageTypeButton: {
                position: "absolute",
                marginTop: "-1.5vw",
                marginLeft: "-1.5vw",
                fontSize: "1.04vw",
                fontWeight: "Regular",  
                color: Color.DeepAsh,
                cvBased: {
                    marginLeft: "72.9vw",
                    marginRight: "1.56vw"
                },
                unlimited: {
                    marginLeft: "1.56vw"
                }
            },
            toggleButton: {
                switch: {
                    height: "2vw",
                    width: "3.22vw"
                },
                switchCircle: {
                    margin: "0.15vw 0.08vw auto",
                    height: "1.68vw",
                    width: "1.68vw",
                }
            },
            disableIcon: {
                height: "1.6vw",
                width: "1.6vw",
                overflow: "visible",
                marginTop: "0.3vw"
            },
        },
        crossPublishing: {
            display: "flex",
            flexDirection: "row" as "row",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "1.56vw 0 3.2vw 0",
            description: {
                width: "28.5vw",
                fontSize: "1vw",
                color: Color.SharpAsh,
                textAlign: "justify"
            },
            title:{
                fontSize: "2.56vw",
                marginTop: "4.04vw"
            },
            descriptionMark: {
                color: Color.SharpAsh,
                fontWeight: 700
            },
             brandList: {
                flexDirection: "row" as "row",
                flexWrap: "wrap" as "wrap",
                justifyContent: "center",
                width: "50.5vw",
                gap: "2.08vw",
                marginTop: "0"
             },
            brandLink: {
                width: "15.5vw",
                 height: "4.7vw",
                 myJobs: {
                    width: "11vw",
                    height: "5.3vw"
                },
                hrNews: {
                    width: "16vw",
                    height: "5.3vw"
                }
            }
        },
        specialPackage: {
            marginTop: "7.07vw",
            background: {
                marginLeft: "13.64vw",
                width: "72.7vw",
                height: "auto",
                borderRadius: "1.04vw",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between"
            },
            title: {
                paddingLeft: "3.125vw",
                paddingTop: "0",
                fontSize: "1.56vw"
            },
            description: {
                fontSize: "2.86vw",
                padding : "1.04vw 0 1.56vw 3.125vw",
                width : "28.5vw"
            },
            button: {
                height: "2.18vw",
                width: "12.5vw",
                borderRadius: "0.52vw",
                margin: "0.78vw 0 2.76vw 3.125vw",
                fontSize: "0.83vw"
            },
            slider: {
                marginLeft: "0",
                paddingRight: "3.125vw",
                marginBottom: "4.42vw"
            },
            featuresContainer: {
                display: 'grid',
                gridTemplateColumns: "repeat(3, 1fr)"
            },
            featureTitle: {
                textAlign: "left", 
                marginLeft: 40,
                fontSize: "1.04vw"
            },
            features: {
                fontSize: '0.93vw',
                maxWidth: "11.7vw",
                paddingBottom: '0.93vw',
                margin: "0"
            },
            featureText: {
                fontSize: "0.93vw"
            }
        },
        review: {
            width: "100%",
            marginTop: "10.94vw",
            overflow: "hidden",
            height: "35.68vw",
            buttonIcon: {
                marginTop: "0.2vw"
            },
            buttonWrapper: {
                display: "flex"
            },
            slider: {                
                height: "24.48vw",
                margin: "1.56vw -7.29vw 0 7.29vw",
                width: "85vw"
            },
            card:{                
                borderRadius: "1.04vw",
                border: "0.21vw solid " + Color.LightBlue, 
                margin: "0 0.83vw 0 0",
                height: "22.39vw",
                width: "calc(100% - 0.83vw)",
                title: {
                    height: "5.37vh",
                    fontSize: "1.04vw",
                    margin: "3.70vh 0 0 2.08vw",
                    lineHeight: 1.2
                },
                quoteIcon: {
                    width: "5.60vw",
                    height: "9.03vh",
                    margin: "1.87vh 1.22vw 0 auto"  
                },
                starWrapper: {
                    margin: "2.78vh 0 0 2.08vw"
                },
                star: {
                    marginRight: "0.15vw",
                    width: "0.9vw",
                    height: "0.70vw"
                },
                description: {
                    height: "14.81vh",
                    margin: "0.92vh 2.08vw 0 2.08vw",
                    fontFamily: "Poppins",
                    fontSize: "0.94vw",
                    fontWeight: "medium" as "medium",
                    color: Color.SharpAsh
                },
                userWrapper: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    margin: "2.04vw 0 3.52vh 2.08vw",
                    width: "16vw"
                },
                userLogo: {
                    width: "3.125vw",
                    height: "3.125vw",                
                    borderRadius: "1.562vw",               
                },
                userName: {
                    height: "2.31vh",
                    fontSize: "0.94vw",
                    marginLeft: "0.78vw",
                    overflow: "hidden"
                },
                userJobTitle: {
                    fontSize: " 0.83vw",
                    margin: "0 0 0 0.78vw",
                    overflow: "hidden"
                },
                organizationLogoWrapper:{
                    margin: "unset",
                    height: "unset"  
                },
                organizationLogo:{
                    width: "6.82vw",
                    height: "3.43vw",
                    borderRadius: "0.78vw",
                    margin: "1.41vw 0 3.52vh auto" 
                },
                bottomWrapper: {
                    height: "10.1vw"
                }            
            }
        },        
        faqs: {            
            flexDirection: "column",
            margin: "2.12vw 7.29vw 0 7.29vw",
            content: {
                width: "19.43vw",
                marginRight: "6.30vw"
            },
            title: {
                width: "43.43vw"
            },
            description: {                
                margin: "2.60vw 0 0 0",                
                fontWeight: 500,
                fontSize: "0.94vw",
                color: Color.SharpAsh,
                width: "68vw"
            },   
            questions: {
                marginTop: "3.52vw",
                width: "59.68vw"
            },
            FAQs: {
                subTitle: {
                    fontSize: "1.041vw",
                    fontWeight: "bold",
                    marginTop: "0",
                    marginLeft: "0",
                    fontFamily: Font.Default,
                    color: Color.SharpAsh
                },
                wrapper: {
                    flexDirection: "row" as "row",
                    marginTop: "0.625vw"
                },
                tabs: {
                    display: "flex",
                    flexDirection: "column" as "column",
                    gap: "0",
                    width: "auto",
                    marginBottom: "0vw",
                    overflowX: "visible" as "visible",
                    overflowY: "visible" as "visible",
                    scrollbarWidth: "auto"
                },
                tabButton: {
                    justifyContent: "space-between",
                    flex: "unset",
                    width: "13.90vw",
                    fontFamily: Font.Default,
                    paddingLeft: "0.74vw",
                    paddingRight: "0.74vw",
                    fontSize: "1.04vw",
                    height: "2.34vw",
                    borderRadius: "0.52vw",
                    marginBottom: "0.52vw",
                    fontWeight: "500",
                    color: Color.SharpAsh,
                    whiteSpace: "normal" as "normal",
                    active: {
                        fontWeight: "500",
                        backgroundColor: Color.LightAsh,
                        border: "0.10vw solid " + Color.Black,
                        color: Color.Black
                    }
                },
                categoryIcon: {
                    display: "none",
                    width: "0.66vw",
                    height: "1.00vw"
                },
                activeIcon: {
                    display: "block",
                    fill: Color.Black,
                    transform: "rotate(270deg)"
                },
                contents: {
                    marginLeft: "2.08vw",
                    marginTop: "0vw",
                },
                content: {
                    question: {
                        fontSize: "1.04vw",
                        fontFamily: Font.Poppins,
                        color: Color.SharpAsh,
                        flexDirection: "row" as "row",
                        width: "70vw",
                        minHeight: "unset",
                        borderRadius: "0.78vw",
                        marginBottom: "0.52vw",
                        border: "none",
                        fontWeight: "bold" as "bold",
                        lineHeight: "1.3",
                        padding: "1.25vw",
                        active: {
                            backgroundColor: Color.DeepBlack,
                            color: Color.White,
                            fontWeight: "bold" as "bold"
                        }
                    },
                    dropdownIcon: {
                        width: "0.81vw",
                        height: "0.46vw",
                        marginLeft: "1vw",
                        marginTop: "0.45vw",
                        active: {
                            transform: "rotate(180deg)",
                            fill: Color.White
                        }
                    },
                    iconWrapper: {
                        width: "2.5vw"
                    },
                    answer: {
                        width: "70vw",
                        fontSize: "0.93vw",
                        lineHeight: "1.5vw",
                        fontWeight: "500",
                        padding: "0 0 0 1.56vw",
                        color: Color.SharpAsh,
                        margin: "0",
                        maxHeight: "0",
                        overflow: "hidden",
                        transition: "max-height 0.5s ease, padding 0.5s ease",
                        active: {
                            maxHeight: "250px",
                            padding: "1.82vw 0 2.60vw 1.56vw"
                        },
                        inactive: {
                            maxHeight: "0",
                            padding: "0 0 0 1.56vw"
                        }
                    },
                    paragraph: {
                        margin: '0 0 0.41vw 0'
                    }
                }
            }
        },
        register: {
            height: "21.875vw",
            borderRadius: "1.04vw",            
            margin: "10.42vw 13.64vw 0 13.64vw",            
            text: {
                padding: "4.95vw 10.625vw 0 10.625vw",
                fontSize: "2.86vw"
            },
            button: {
                height: "3.64vw",
                width: "14.58vw",
                marginTop: "2.08vw",
                fontSize: "1.04vw",
                borderRadius: "0.52vw"
            },
            backgroundSvg: {
                position: "absolute",
                left: "-0.51vw",
                bottom: "0",
                width: "72.7vw",
                height: "52.1%",
                marginLeft: "0",
                borderRadius: "2.08vw"
            }
        },
        bestHire: {            
            flexDirection: "row",
            margin: "10.42vw 7.29vw 0 7.29vw",  
            textAlign: "left",  
            content: {
                width: "25.88vw",
                margin: "7.19vw 10.05vw 0 0"
            },          
            description: {
                width: "25.88vw",                
                fontSize: "0.9375vw",
                fontWeight: 500,
                marginTop: "2.60vw",
                color: Color.SharpAsh
            },
            video: {
                width: "49.48vw",
                height: "31.61vw",                
                borderRadius :"1.04vw",
                marginTop: "0"
            }
        }
    }
}
